var render = function render(){var _vm=this,_c=_vm._self._c;return _c('canvas',{attrs:{"id":"renderCanvas"},on:{"wheel":function($event){return $event.preventDefault();}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }